import React from 'react';

interface SubmitButtonProps {
    isLoading: boolean;
    isDisabled: boolean;
    onClick: () => void;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ isLoading, isDisabled, onClick }) => (
    <div className="cf-submit-wrapper">
        <button
            type="button"
            className={`cf-submit-btn${isDisabled || isLoading ? ' cf-submit-btn--disabled' : ''}`}
            onClick={onClick}
            disabled={isDisabled || isLoading}
            id="cf-submit"
        >
            {isLoading ? (
                <span className="cf-dots">
                    <span className="cf-dot" />
                    <span className="cf-dot" />
                    <span className="cf-dot" />
                </span>
            ) : (
                'צרו איתי קשר'
            )}
        </button>
    </div>
);

export default SubmitButton;
